import Cookies from 'js-cookie';
import isMobile from 'ismobilejs';
import platform from 'platform';
import { DeviceOs, DeviceOsValues } from '../logic/main/types';
import Window from '../ports-backend/Window';

function getDeviceTypeFromBrowser({
  phone,
  tablet,
}: {
  phone: boolean;
  tablet: boolean;
}) {
  if (phone) {
    return 'mobile';
  } else if (tablet) {
    return 'tablet';
  }

  return 'desktop';
}

function getDeviceOs(): DeviceOs {
  const userOSFamily = platform.os?.family?.toLowerCase();
  if (!userOSFamily) return null;
  const supportedOSystems = Object.values(DeviceOsValues);
  const userOs = supportedOSystems.find(os => userOSFamily.includes(os));
  return userOs || null;
}

const isNative = () => {
  return !!Window.invoke.getAssemblerContext().is_native;
};

const deviceDetection = {
  invoke: {
    getDeviceInfo: () => {
      const deviceCookie = Cookies.getJSON('wh_device');
      const { nativeDeviceOs = null, appVersion = null } =
        (deviceCookie && {
          nativeDeviceOs: deviceCookie['device_os'].toLowerCase(),
          appVersion: deviceCookie['app_version'],
        }) ||
        {};

      const deviceType = isMobile();
      return {
        isNative: isNative(),
        nativeDeviceOs,
        appVersion,
        deviceType: getDeviceTypeFromBrowser(deviceType),
        deviceOs: getDeviceOs(),
      };
    },
  },
};

export default deviceDetection;
